<template>
  <Dialog
    width="95%"
    top="5vh"
    :visible="visible"
    @close="handleClose"
  >
    <div
      ref="detail"
      style="height: 620px;"
    />
  </Dialog>
</template>

<script>
import { Dialog } from 'element-ui';
import echart from 'echarts';
import { createNamespacedHelpers } from 'vuex';

import chartMixin from '../mixins/chart';

const { mapState } = createNamespacedHelpers('directSaleReport/dataView');

export default {
  components: {
    Dialog,
  },

  mixins: [chartMixin],

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState({
      activeAccount: (state) => state.activeAccount,
      newAccount: (state) => state.newAccount,
      newProduct: (state) => state.newProduct,
      type: (state) => state.type,
    }),

    dataSource() {
      if (this.type === 'active_account') {
        return this.activeAccount;
      } else if (this.type === 'new_account') {
        return this.newAccount;
      } else {
        return this.newProduct;
      }
    },
  },

  watch: {
    visible(newVal) {
      if (!this.chart && newVal) {
        this.$nextTick(() => {
          this.chart = echart.init(this.$refs.detail);
          this.render();
        });
      }

      if (newVal) {
        this.$nextTick(() => {
          this.render();
        });
      }
    },
  },

  methods: {
    handleClose() {
      this.$emit('close', false);
    },

    render() {
      const option = this.getOption();
      const defaultOption = {
        grid: {
          top: 60,
          bottom: 80,
          right: 60,
          left: 60,
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100,
          },
          {
            start: 0,
            end: 100,
            handleIcon:
              'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            handleSize: '80%',
            handleStyle: {
              color: '#fff',
              shadowBlur: 3,
              shadowColor: 'rgba(0, 0, 0, 0.6)',
              shadowOffsetX: 2,
              shadowOffsetY: 2,
            },
          },
        ],
      };

      this.chart.setOption({ ...option, ...defaultOption }, true);
    },
  },
};
</script>